(function () {
  
  function showIsSubscribed() {
    let subscr_label = document.querySelector(
      ".onsite-subscribtion-email-label"
    );
    let subscribed_label = document.querySelector(
      ".onsite-subscribtion-email-label-subscribed"
    );
    subscr_label.style.display = "none";
    subscribed_label.style.display = "block";

    setTimeout(() => {
      // Hide popup after 2 seconds 
      const modal = document.getElementById("klaviyo-onsite-modal");
      modal.style.display = "none";
    }, 2000);
  }
  
  function handleSubmit(event) {
    event.preventDefault();
    const post_data = new FormData(event.target);
    const emailValue = post_data.get("onsite-subscribtion-email");
    const variantId = "$shopify:::$default:::" + post_data.get("size");

    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: { email: emailValue },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: variantId,
            },
          },
        },
      },
    };

    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
        "Access-Control-Allow-Origin": "*",
      },
      body: JSON.stringify(payload),
    };

    fetch(
      "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id="+getApiKey(),
      requestOptions
    )
      .then((result) => {
        if (result.ok) {
          showIsSubscribed();
        }
      })
      .catch((error) => console.log("error", error));
  }

  function getApiKey(){
    let apiKey;
    
    switch (window.location.hostname) {
      case 'us.karhu.com': apiKey = 'S4XH8S'; break;
      case 'es.karhu.com': apiKey = 'Y6FLy7'; break;
      case 'eu.karhu.com': apiKey = 'TQhH2J'; break;
      case 'karhu.com': apiKey = 'TQhH2J'; break;
      case 'fr.karhu.com': apiKey = 'UsYfmk'; break;        
      case 'it.karhu.com': apiKey = 'Y9JM7v'; break;
      case 'nl.karhu.com': apiKey = 'XdEcTQ'; break;
      case 'se.karhu.com': apiKey = 'TK6Wjm'; break;
      case 'uk.karhu.com': apiKey = 'TCzrNU'; break;  
      case 'de.karhu.com': apiKey = 'WaxCuY'; break;
      case 'fi.karhu.com': apiKey = 'XyJYAS'; break;
    }
    return apiKey;
}
    
  //Submit notification form
  const onsite_form = document.getElementById("klaviyo-onsite-notify-form");
  onsite_form.addEventListener("submit", (event) => {
    event.preventDefault();
    handleSubmit(event);
  });
  
})();
